import Pre from "@ui/pre/Pre";
import { Box } from "@ui/box/Box";
import { Error } from "@ui/error/Error";
import { Spinner } from "@ui/spinner/Spinner";
import { GD } from "src/GD";

export const EventClip = ({ id }: { id: number }) => {
	const [res, _1, _2, busy] = GD.REQ_EVENT.useRequest(undefined, {
		id: id,
	});

	return (
		<Box
			sx={{
				padding: "20px",
				backgroundColor: "white",
				borderRadius: "10px",
			}}>
			{res?.data && (
				<Pre data={res.data} wrap />
			)} 
			{/* {res?.data && <Typo variant="text">{res.data.data}</Typo>} */}
			<Error error={res?.error} />
			{busy && <Spinner />}
		</Box>
	);
};
